import { Box, styled } from "@mui/material";

import { PageTitle } from "@/components/page.title";
import { StyleUtils } from "@/constants/style.utils";

export const ContentWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6.4, 2.4),
  minHeight: "100%",
}));

export const QuestionText = styled(PageTitle)(({ theme }) => ({
  border: `1px solid ${theme.palette.common.white}`,
  borderRadius: StyleUtils.border.radius(1),
  padding: theme.spacing(1),
}));

export const DatePickerWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  "& .MuiTextField-root": {
    width: "100%",
    maxWidth: "400px",
  },
  "& .MuiInputBase-input": {
    fontSize: StyleUtils.fonts.size(3.5),
    color: theme.palette.common.white,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.common.white,
  },
  "& .MuiInputLabel-root": {
    fontSize: StyleUtils.fonts.size(3),
    color: theme.palette.common.white,
  },
  "& .MuiSvgIcon-root": {
    color: theme.palette.common.white,
  },
}));

